export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/ucenter/system/roles',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/ucenter/system/roles',
      method: 'POST'
    },
    {
      path: '/ucenter/system/menus',
      method: 'GET'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/ucenter/system/roles/{roleId}',
      method: 'PUT'
    },
    {
      path: '/ucenter/system/menus',
      method: 'GET'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/ucenter/system/roles/{roleId}',
      method: 'DELETE'
    }]
  }
}